import React from "react";
import { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser"
const Join = () => {
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_q7oq0ia', 'template_3cqa763', form.current, 'YaxdtVVVt0miv81ff')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
    const form= useRef()
  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text">WITH US?</span>
        </div>
      </div>
      <div className="right-j">
        <form  ref={form} className="email-container" onSubmit={sendEmail}>
            <input type="email" name="user_email" placeholder="ENTER YOUR EMAIL HERE" />
            <button className="btn">JOIN NOW</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
